import React from "react";
import { Editor, Text, MultipleUpload } from "components/fields";
import { useSelector } from "react-redux";

import "./index.scss";


export default ({ form, isVariant, removeImage }) => {

	const { profile } = useSelector(({ auth }) => auth);
	const isBusiness = profile && profile.subscription && (profile.subscription.id === 1 || profile.subscription.id === 5);

	const markAsDefault = (uniqid) => {
		form.setFieldValue("default_image", uniqid);
	}

	return <div>

		<div className="product-form-main-back pb-0">

			<Text name="title" placeholder="Product Title" label="Title" {...form} />

			<Editor label="Description" name="description" {...form} />

			<div className="mb-4">
				<MultipleUpload isBusiness={isBusiness} default_image={form.values.default_image} mark={markAsDefault} isMulti name="image" remove={removeImage} {...form} label={<>Images&nbsp;<small>(optional)</small></>}/>
			</div>

			<Text wrapperClassName="mb-0" placeholder="https://youtube.com/sample-video" label={<>Youtube Link&nbsp;<small>(optional)</small></>} name="youtube_link" {...form} />

		</div>
	</div>
}